import { useQuery } from "@tanstack/react-query";
import { getAtreemoStatus } from "../../api/bAtreemoApi";

export const useGetAtreemoStatus = (organisationId, locationId=null, brandId=null, enabled = true) => {
  return useQuery({
    queryKey: ["atreemo-status", organisationId, locationId, brandId],
    queryFn: () => getAtreemoStatus(organisationId, locationId, brandId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};